export default __webpack_public_path__ + "static/media/logoBig.19333836.png";